import tokens from '@audi/audi-ui-design-tokens';
export const responsiveTypography = {
    order1: {
        xs: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_1_XS_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_1_XS_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_1_XS_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_1_XS_LINE_HEIGHT,
        },
        s: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_1_S_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_1_S_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_1_S_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_1_S_LINE_HEIGHT,
        },
        m: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_1_M_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_1_M_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_1_M_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_1_M_LINE_HEIGHT,
        },
        l: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_1_L_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_1_L_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_1_L_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_1_L_LINE_HEIGHT,
        },
        xl: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_1_XL_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_1_XL_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_1_XL_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_1_XL_LINE_HEIGHT,
        },
        xxl: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_1_XXL_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_1_XXL_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_1_XXL_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_1_XXL_LINE_HEIGHT,
        },
    },
    order2: {
        xs: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_2_XS_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_2_XS_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_2_XS_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_2_XS_LINE_HEIGHT,
        },
        s: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_2_S_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_2_S_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_2_S_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_2_S_LINE_HEIGHT,
        },
        m: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_2_M_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_2_M_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_2_M_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_2_M_LINE_HEIGHT,
        },
        l: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_2_L_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_2_L_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_2_L_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_2_L_LINE_HEIGHT,
        },
        xl: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_2_XL_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_2_XL_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_2_XL_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_2_XL_LINE_HEIGHT,
        },
        xxl: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_2_XXL_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_2_XXL_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_2_XXL_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_2_XXL_LINE_HEIGHT,
        },
    },
    order3: {
        xs: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_3_XS_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_3_XS_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_3_XS_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_3_XS_LINE_HEIGHT,
        },
        s: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_3_S_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_3_S_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_3_S_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_3_S_LINE_HEIGHT,
        },
        m: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_3_M_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_3_M_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_3_M_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_3_M_LINE_HEIGHT,
        },
        l: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_3_L_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_3_L_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_3_L_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_3_L_LINE_HEIGHT,
        },
        xl: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_3_XL_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_3_XL_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_3_XL_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_3_XL_LINE_HEIGHT,
        },
        xxl: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_3_XXL_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_3_XXL_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_3_XXL_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_3_XXL_LINE_HEIGHT,
        },
    },
    order4: {
        xs: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_4_XS_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_4_XS_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_4_XS_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_4_XS_LINE_HEIGHT,
        },
        s: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_4_S_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_4_S_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_4_S_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_4_S_LINE_HEIGHT,
        },
        m: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_4_M_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_4_M_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_4_M_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_4_M_LINE_HEIGHT,
        },
        l: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_4_L_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_4_L_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_4_L_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_4_L_LINE_HEIGHT,
        },
        xl: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_4_XL_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_4_XL_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_4_XL_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_4_XL_LINE_HEIGHT,
        },
        xxl: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_ORDER_4_XXL_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_ORDER_4_XXL_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_ORDER_4_XXL_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_ORDER_4_XXL_LINE_HEIGHT,
        },
    },
    display1: {
        xs: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_XS_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_XS_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_XS_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_XS_LINE_HEIGHT,
        },
        s: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_S_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_S_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_S_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_S_LINE_HEIGHT,
        },
        m: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_M_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_M_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_M_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_M_LINE_HEIGHT,
        },
        l: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_L_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_L_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_L_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_L_LINE_HEIGHT,
        },
        xl: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_XL_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_XL_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_XL_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_XL_LINE_HEIGHT,
        },
        xxl: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_XXL_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_XXL_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_XXL_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_DISPLAY_1_XXL_LINE_HEIGHT,
        },
    },
    display2: {
        xs: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_XS_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_XS_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_XS_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_XS_LINE_HEIGHT,
        },
        s: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_S_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_S_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_S_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_S_LINE_HEIGHT,
        },
        m: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_M_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_M_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_M_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_M_LINE_HEIGHT,
        },
        l: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_L_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_L_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_L_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_L_LINE_HEIGHT,
        },
        xl: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_XL_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_XL_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_XL_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_XL_LINE_HEIGHT,
        },
        xxl: {
            fontFamily: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_XXL_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_XXL_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_XXL_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_HEADING_DISPLAY_2_XXL_LINE_HEIGHT,
        },
    },
    copy1: {
        xs: {
            fontFamily: tokens.TYPOGRAPHY_COPY_1_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_COPY_1_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_COPY_1_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_COPY_1_LINE_HEIGHT,
        },
    },
    copy2: {
        xs: {
            fontFamily: tokens.TYPOGRAPHY_COPY_2_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_COPY_2_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_COPY_2_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_COPY_2_LINE_HEIGHT,
        },
    },
    copy3: {
        xs: {
            fontFamily: tokens.TYPOGRAPHY_COPY_3_FONT_FAMILY,
            fontSize: tokens.TYPOGRAPHY_COPY_3_FONT_SIZE,
            fontStretch: tokens.TYPOGRAPHY_COPY_3_FONT_STRETCH,
            lineHeight: tokens.TYPOGRAPHY_COPY_3_LINE_HEIGHT,
        },
    },
};
export const typographyVariantLabels = Object.keys(responsiveTypography);
//# sourceMappingURL=audi-typography.js.map